import React, { useState, useEffect, useRef } from "react";
import { MSG } from "../../constants/toastMessages";
import { BiDownload, BiFile, BiPowerOff } from "react-icons/bi";
import { toast } from 'react-toastify';
import { apiCallingPost, prepareDownload } from '../../api/services';
import useDownloadLock from '../../hooks/useDownloadLock';
import startBrowserDownload from '../../utils/startBrowserDownload';
import { shareLinkFromLocation } from '../../utils/shareLink';
import { FaDownload, FaEye } from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";
// import Logo from "../../assets/images/logo-blue.svg"
import Logo from "../../assets/images/logo.webp"

import JSZip from "jszip";
import { saveAs } from "file-saver";
import moment from 'moment';
import { useSelector } from 'react-redux';
import { setPageUrl } from "../../redux/reducers/authSlice";
import { useDispatch } from "react-redux";
import MediaPreview from '../../components/MediaPreview';
import LargeBundleNote from '../../components/LargeBundleNote';
function ListVideo() {

  const [requestDetails, setRequestDetails] = useState([])
  const [messageExpired, setMessageExpired] = useState("")
  const [totalCount, setTotalCount] = useState(null)
  const [totalFileSize, setTotalFileSize] = useState(0)
  const [mode, setmode] = useState(null)
  const [expireAt, setExpireAt] = useState("")
  const [showVideo, setShowVideo] = useState(false);
  const [videoUrl, setVideoUrl] = useState("")
  const { isAuthenticated } = useSelector((state) => state.authentication)
  const [selectedQualities, setSelectedQualities] = useState({});
  const [setFileType, setSetFileType] = useState("")
  const [previewQuality, setPreviewQuality] = useState(null)
  const dispatch = useDispatch();

  if (!isAuthenticated) {
    dispatch(setPageUrl(window.location.pathname))
    window.location.href = "/login"

  }
  // The share's identity is its address WITHOUT any query, fragment or trailing slash a
  // mail client may append; it must match the link saved at share time exactly.
  const shareLink = shareLinkFromLocation()
  useEffect(() => {
    // Logged-out visitors are on their way to /login (above); the check needs a session.
    if (isAuthenticated) shareRequestExpire()

  }, [])

  const shareRequestExpire = async (list) => {
    const initialSelectedQualities = {};

    let postData = {
      encodedVideoUrl: shareLink
    }

    try {
      const response = await apiCallingPost("api/video/checkShareRequestDurationExpire", postData);
      const { data } = response;
      //console.log("🚀 ~ shareRequestExpire ~ data:", data)
      if (data.success === "1") {
        setRequestDetails(data.result?.[0]?.requestDetails)
        setMessageExpired(data.result?.[0]?.message)
        setTotalCount(data.result?.[0]?.totalCount)
        setTotalFileSize(data.result?.[0]?.totalFileSize)
        setmode(data.result?.[0]?.mode)
        const formattedDate = moment(JSON.parse(data.result?.[0]?.expires_at)).format('MMM D, YYYY, h:mm:ss A');
        setExpireAt(formattedDate)

        data.result?.[0]?.requestDetails.forEach((video) => {
          if (video.download_mp4 && !video.download_original && video.qualityTypeArray.length > 0) {
            initialSelectedQualities[video.video_id] = {
              quality: video.qualityTypeArray[0].qualitytype,
              size: video.qualityTypeArray[0].qualityvideosize,
            };
          } else {
            // Use original
            initialSelectedQualities[video.video_id] = {
              quality: "Download Original",
              size: Number(video.file_size),
            };
          }
        });
        setSelectedQualities(initialSelectedQualities);
        const totalSizeMB = Object.values(initialSelectedQualities).reduce(
          (sum, item) => sum + Number(item.size),
          0
        );
        setTotalFileSize(totalSizeMB.toFixed(1));
      }
      else {
        toast.error(MSG.genericError);
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  }
  const getTotalSize = (videos) => {
    const totalMB = videos.reduce((sum, video) => sum + Number(video.file_size), 0);

    if (totalMB >= 1024 * 1024) {
      const totalTB = totalMB / (1024 * 1024);
      return `${totalTB.toFixed(1)} TB`;
    } else if (totalMB >= 1024) {
      const totalGB = totalMB / 1024;
      return `${totalGB.toFixed(1)} GB`;
    } else {
      return `${totalMB.toFixed(1)} MB`;
    }
  };
  const getSelectedQualityArray = () => {
    return requestDetails.map((video) => {
      const selected = selectedQualities[video.video_id];
      return {
        fileId: video.video_id,
        type: selected?.quality === "Download Original" || !selected?.quality ? "" : selected.quality,
      };
    });
  };

  const { isLocked, runLocked } = useDownloadLock();
  const handleDownloadAll = () => runLocked('all', async () => {
    try {
      const selectedResolutionArray = getSelectedQualityArray();
      const { responseData } = await prepareDownload(selectedResolutionArray, shareLink);
      startBrowserDownload(responseData, "video.zip");
      toast.success(MSG.downloadStarted);
    } catch (err) {
      console.error("Download all failed", err);
      toast.error(MSG.downloadFailed);
    }
  });

  const handleToggleVideo = (url, fileTypeId, qualityTypeArray) => {
    setShowVideo(true);
    setVideoUrl(url);
    setSetFileType(fileTypeId);
    setPreviewQuality(qualityTypeArray || null);
  };
  const cancelpopup = () => {
    window.location.href = "/"
  }
  const getTotalSizeMB = (mb) => {
    if (mb >= 1024 * 1024) return `${(mb / (1024 * 1024)).toFixed(1)} TB`;
    if (mb >= 1024) return `${(mb / 1024).toFixed(1)} GB`;
    return `${mb} MB`;
  };
  const handleQualityChange = (videoId, selectedQuality, sizes) => {
    const selectedVideoSize = sizes.find(q => q.qualitytype === selectedQuality)?.qualityvideosize || 0;
    setSelectedQualities(prev => {
      const updated = {
        ...prev,
        [videoId]: { quality: selectedQuality, size: selectedVideoSize }
      };

      // Update total size
      const totalSizeMB = requestDetails.reduce((sum, video) => {
        const selected = updated[video.video_id];
        return sum + (selected?.size ? Number(selected.size) : Number(video.file_size));
      }, 0);
      setTotalFileSize(totalSizeMB.toFixed(1));

      return updated;
    });
  };
  const handleSingleDownload = (video, selectedQualityObj) => runLocked(video.video_id, async () => {
    const resolutionType = selectedQualityObj?.quality === "Download Original" || !selectedQualityObj?.quality
      ? ""
      : selectedQualityObj.quality;
    const requestPayload = [{
      fileId: video.video_id,
      type: resolutionType
    }];
    try {
      const { responseData } = await prepareDownload(requestPayload, shareLink);
      startBrowserDownload(responseData, `${video.fileName}.${video.file_extension}`);
      toast.success(MSG.downloadStarted);
    } catch (err) {
      console.error("Single download failed", err);
      toast.error(MSG.downloadFailed);
    }
  });

  return (
    isAuthenticated && (
      <div className="share-page">
        <div className="p-4">
        <a className='login_logo' href="/">
          <img src={Logo} alt="Logo" className="img-fluid logo-change" width="120" height="50" />
        </a>
        </div>
        {messageExpired == "Expired" ?
        <div className="share-card">
          <div className="">
            <h5 className=" text-center px-4 mb-0">
              The link you’re trying to access is no longer valid or has expired.
            </h5>
          </div>
          </div>
          :
          <div className="share-card">
            <div className="modal-innerpopup ">
              <div className="modal-headdiv d-flex justify-content-between">
                <h5 className="modal-head">Files are Ready!</h5>
                <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span>
              </div>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div className="d-flex align-items-center gap-2"> <BiFile /><strong>{totalCount} files, {getTotalSizeMB(totalFileSize)} </strong></div>
                <div className="d-flex align-items-center gap-2 ms-auto"><BiPowerOff /><strong>Expires on {expireAt}</strong></div>
              </div>
              <LargeBundleNote totalMb={totalFileSize} />
              <div className="modal-admin-body my-3">
                <div className="table-responsive">
                  <table className="table table-bordered admin-list-table">

                    <tbody>

                      {requestDetails.map((data, i) => {
                        return (
                          < tr key={i} >
                            <td style={mode === "Download"
                              ? { width: '40%', minWidth: '250px' }
                              : { width: '70%', minWidth: '250px' }}>{data.video_name}{"." + data.file_extension}</td>
                            <td style={{ width: '20%', minWidth: '100px' }}>
                              {selectedQualities[data.video_id]?.size
                                ? `${selectedQualities[data.video_id].size} MB`
                                : (data.download_mp4 && !data.download_original) ? data.qualityTypeArray.length > 0 ? `${data.qualityTypeArray[0].qualityvideosize} MB` : `${data.file_size} MB` : `${data.file_size} MB`}
                            </td>
                            <td style={mode === "Download"
                              ? { width: '40%', minWidth: '250px' }
                              : { width: '10%', minWidth: '60px' }}>
                              <div className="d-flex align-items-center gap-3"
                                style={{ color: '#00627B' }}
                              >
                                {mode === "Download" &&
                                  <select name="" id="" className='form-control form-select-drop'
                                    value={selectedQualities[data.video_id]?.quality || "Download Original"}
                                    onChange={(e) =>
                                      handleQualityChange(data.video_id, e.target.value, data.qualityTypeArray)
                                    }
                                  >
                                    {(data.download_original || data.fileTypeId == "1") &&
                                      <option value="Download Original" >Download Original</option>}
                                    {data.download_mp4 &&
                                      data.qualityTypeArray.map((obj, j) => (
                                        <option key={j} value={obj.qualitytype}>{obj.qualitytype}</option>
                                      ))}
                                  </select>}

                                <FaEye style={{ cursor: 'pointer', fontSize: '24px', flex: 'none' }} onClick={() => handleToggleVideo(data.videoUrl, data.fileTypeId, data.qualityTypeArray)} />
                                {mode === "Download" &&
                                  <span
                                    style={{
                                      flex: 'none',
                                      opacity: isLocked(data.video_id) ? 0.5 : 1,
                                      cursor: isLocked(data.video_id) ? 'default' : 'pointer',
                                    }}
                                    onClick={() => !isLocked(data.video_id) && handleSingleDownload(data, selectedQualities[data.video_id])}
                                  >
                                    {isLocked(data.video_id)
                                      ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                      : <FaDownload />}
                                  </span>}
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>

                  </table>
                </div>
              </div>
              <div className="tag-popup-footer">
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="accept-all-btn w-100 py-2 accept-all-gray"
                    onClick={() => cancelpopup()}
                  >
                    Cancel
                  </button>
                  {mode === "Download" &&
                    (<button
                      type="button"
                      className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                      onClick={() => handleDownloadAll()}
                      disabled={isLocked('all')}
                    >
                      {isLocked('all')
                        ? <><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> Starting…</>
                        : <>Download all <BiDownload className="ms-0" /></>}
                    </button>)}
                </div>
              </div>
            </div>
          </div>}
        <MediaPreview
          open={showVideo}
          url={videoUrl}
          fileType={setFileType}
          qualityTypeArray={previewQuality}
          onClose={() => setShowVideo(false)}
          autoPlay
        />
      </div >
    )
  );
}
export default ListVideo;